import React from 'react';
import { Copy, Stack } from '@grubhubprod/gh-cookbook-react';
import { useSendAnalytics } from 'src/components/AnalyticsProvider/useSendAnalytics';
import { ZipGenerateStateButton } from 'src/components/selfService/features/OrderHistory/ZipDownload/buttons/ZipGenerateStateButton';
import { Tooltip } from 'src/components/Tooltip/Tooltip';

export interface ZipGenerateStateWrapperProps {
  onClick: () => void;
  isDisabled?: boolean;
  isDateRangeSelected?: boolean;
}

export function ZipGenerateStateWrapper({
  onClick,
  isDisabled,
  isDateRangeSelected,
}: ZipGenerateStateWrapperProps): JSX.Element {
  const { sendAnalyticsBefore } = useSendAnalytics({
    eventcategory: 'self-service management tool_orderhistory',
    eventaction: 'bulk download receipts_cta',
  });
  return (
    <Tooltip
      maxWidth="190px"
      roundedContainer
      disabled={isDateRangeSelected}
      content={
        <Copy variant="body" color="invertedPrimaryText">
          Select a date range to download receipts.
        </Copy>
      }
    >
      <Stack>
        <ZipGenerateStateButton
          isDisabled={isDisabled}
          onClick={() => sendAnalyticsBefore(onClick)}
        />
      </Stack>
    </Tooltip>
  );
}
